var Collections = require("./src/collections/index.js");

var TreeNode =  {
    makeTreeNode : function(root){
        this._parent = null;
        this.children = new Collections.HashMap();
    },

    /**
     * Find extension in the upstream tree.
     * @param {(function() | String)} toFind extension name or class to look for
     */
    _findUpstream : function (toFind) {
        console.assert(toFind != null, "can't search for null");
        switch(typeof toFind) {
            case "string":
                if (this.children.contains(toFind)) {
                    return this.children.get(toFind);
                }
                break;
            case "function":
                // Loop over own level
                var result = false;
                this.children.forEach(function(childName, child){
                    if(child instanceof toFind) result = child;
                });
                if(result) return result;
                // Check parent
                if (this instanceof toFind || this.constructor == toFind) {
                    return this;
                }
                break;
        }

        if (this.parent()) {
            return this.parent()._findUpstream(toFind);
        } else {
            return null;
        }
    },

    /**
     * Find extension in the upstream tree that returns true for the checker function.
     * @param {(function())} checker function that needs to match
     */
    findUpstreamWithFilter : function (filter) {
        console.assert(filter !== undefined);

        if (filter.call(this)) {
            return this;
        } else if (this.parent()) {
            return this.parent().findUpstreamWithFilter(filter);
        } else {
            return;
        }
    },

    /**
     * Find extensions in the downstream tree.
     * @param {(function() | String)} toFind extension name or class to look for
     */
    findDownstream : function (toFind, prevMatches) {
        var matches = prevMatches || [];
        this.children.forEach(function(key, value) {
            switch(typeof toFind) {
                case "string":
                    if (key == toFind)
                        matches.push(value);
                    break;
                case "function":
                    if (value instanceof toFind ||
                        value.constructor == toFind)
                        matches.push(value);
                    break;
            }
            value.findDownstream(toFind, matches);
        });
        return matches;
    },

    /**
     * Setter/Getter for the parent
     */
    parent : function (parent) {
        if(parent) {
            console.assert(!this._parent, "Parent should be assigned only once!");
            this._parent = parent;
            this._parent.children.put(this.name(), this);
        } else {
            return this._parent;
        }
    }
};
module.exports = TreeNode;
